import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'insider-logged_out_insider_marketing_page-view';
/**
 * logged out insider marketing page
 */ export function trackInsiderLoggedOutInsiderMarketingPageView() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false
    });
}
